import React from 'react';
import T from 'prop-types';

const ShrinkedText = ({ className, length, children, ...otherProps }) => {
  const shrinkText = () => {
    if (children.length <= length) {
      return children;
    }
    return children.substring(0, length) + '...';
  };

  const text =
    (typeof children === 'string' || children instanceof String) &&
    shrinkText();

  return (
    <pre className={className} {...otherProps}>
      {text}
    </pre>
  );
};

ShrinkedText.propTypes = {
  className: T.string,
  length: T.number.isRequired
};

export default ShrinkedText;



// WEBPACK FOOTER //
// ./src/components/ShrinkedText/ShrinkedText.jsx